module.exports = __webpack_public_path__ + "static/media/208-palestine.662d6afc.svg";